'use strict';

angular.module('shiftTraderApp')
    .directive('saWeekColorBar', ['TimeService', function (TimeService) {
      return {
        templateUrl: 'views/directives/saWeekColorBar.html',
        restrict: 'EA',
        scope: {
          'dayInWeek':'@', //should be 1 through 7
          'weekTwix':'=',
          'labels': '=',
          'linkfunction': '&'
        },
        link: function(scope, elem) {
          if (_.isUndefined(scope.labels)) {
            //scope.labels = ['','','','','','',''];
            scope.labelsToUse = ['','','','','','',''];
          } else {
            scope.labelsToUse = _.cloneDeep(scope.labels);
          }

          var numDays;
          if (_.isUndefined(scope.dayInWeek)) {
            scope.currentTime = TimeService.getNowInStoreTime();
            numDays = Math.floor(moment(scope.weekTwix.start).twix(scope.currentTime).length('hours') / 24.0) + 1;
          } else {
            numDays = parseInt(scope.dayInWeek);
          }

          var percentShift = -1 * (7 - numDays) * 14.25;

          $(elem).find('.moving').css('left', percentShift + '%');
          scope.dateText = scope.weekTwix.start.format('MMM D') + ' to ' + moment(scope.weekTwix.end).subtract(12, 'hours').format('MMM D');

          scope.labelInPosition = function(barNum) {
            if ((barNum - (7 - numDays)) < 0) {
              return '';
            } else {
              return scope.labelsToUse[barNum - (7 - numDays)];
            }
          };

          scope.callLinkFn = function(barNum, movingBar) {
            if (!_.isUndefined(scope.linkfunction)) {
              if(_.isUndefined(movingBar)) {
                scope.linkfunction()(barNum);
              } else {
                scope.linkfunction()(barNum - (7 - numDays));
              }
            }
          };
        }
      };
    }]);
